import {booleanPlanPropertiesMapper} from "../physicianProfileAndPlans/booleamPropertiesMapper.js";
import UpcomingPlanChanges from "../physicianProfileAndPlans/UpcomingPlanChanges.vue";
import PlanDetailsModal from "../physicianProfileAndPlans/PlanDetailsModal.vue";

import slimScroll from 'jquery-slimscroll';

export const physcianPlansMixin = {
	props: {
		providerEntityId: {type: [Number], required: true},
	},
	components: {UpcomingPlanChanges, PlanDetailsModal},
	data() {
		return {
			plans: [],
			planMapper: booleanPlanPropertiesMapper
		}
	},
	computed: {
		hasCustomContent() {
			return Boolean(this.$scopedSlots.default);
		}
	},
	methods: {
		async baseInit(detailsUrl) {
			let data = await $.ajax({
				type: "Get",
				url: detailsUrl
			});
			let rawPlans = data.plans;
			this.plans = rawPlans.map(plan => ({
				...plan,
				doesNotChargeVisitFee: !plan.chargesVisitFee,
				doesNotChargeUrgentCareFee: !plan.chargesUrgentCareFee
			}));
			this.isProviderAcceptingNewPatients = data.isProviderAcceptingNewPatients;
			this.addSlimScroll();
		},
		showAllPlanDetails(planId) {
			this.$refs.planDetailsModal.showModal(planId);
		},
		async addSlimScroll() {
			await this.$nextTick();
			$('.open-plan-template-container').slimScroll({
				color: '#555',
				size: '8px',
				height: '250px',
				alwaysVisible: false,
			});
		}
	}
};